import { render, staticRenderFns } from "./PublishingContractsSubCataloguesReadOnlyPanel.vue?vue&type=template&id=d8d8a536"
import script from "./PublishingContractsSubCataloguesReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsSubCataloguesReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsSubCataloguesReadOnlyPanel.vue?vue&type=style&index=0&id=d8d8a536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports